import styled, { css } from 'styled-components';
import { mdBold } from '../theme/typography';
import { themeColor } from '../theme/colors';

export const Container = styled.div`
  ${mdBold};

  display: flex;
  gap: 4px;
  max-width: 52vw;
  word-break: break-word;
`;

export const Item = styled.div<{ $nowrap?: boolean }>`
  & a {
    color: ${themeColor('textTertiary')};

    text-decoration: inherit;
    &:hover {
      text-decoration: underline;
    }
  }

  &:first-child {
    a:before {
      color: ${themeColor('textTertiary')};
      content: '← ';
    }
    &:after {
      color: ${themeColor('textTertiary')};
      content: ' / ';
    }
  }

  ${({ $nowrap }) =>
    !!$nowrap &&
    css`
      white-space: nowrap;
    `}
`;

export const ColoredItem = styled(Item)`
  background: linear-gradient(90deg, #ad86ed 0%, #25fce7 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
